import { ChatbotContext } from 'providers/ChatbotProvider';
import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import useFetch from 'use-http';

const useBotReply = () => {
    const { setBotReplyLoading } = useContext(ChatbotContext);
    const { post } = useFetch();

    const getBotReply = useCallback(
        async (request) => {
            setBotReplyLoading(true);
            const url = `/get_bot_response_anonymous`;

            try {
                const response = await post(url, request);
                console.log({ getBotReply: response });

                const isSuccess = !!response?.answers;
                // toast[isSuccess ? 'success' : 'error'](response.message);

                return { isSuccess, botResponse: response };
            } catch (err) {
                console.error(err);
                toast.error('Something went wrong, please try again later');
                throw err;
            } finally {
                setBotReplyLoading(false);
            }
        },
        [post, setBotReplyLoading]
    );

    return { getBotReply };
};

export default useBotReply;
